import { Grid, Typography } from "@material-ui/core";
import { CustomModal } from "../../../common/modal";
import useModal from "../../hooks/useModal";
import { LearningTabIcon } from "../../icons/LearningTabIcon";
import { LessonCollectibleDetail } from "../lesson-collectible-detail";
import { useStyles } from "./lesson-collectible.styles";

interface LessonCollectibleProps {
  categoryName: string;
  imagePath: string;
  title: string;
  slideId: number;
  date: Date;
  column: boolean;
}

const LessonCollectible = ({
  title,
  imagePath,
  column,
  slideId,
}: LessonCollectibleProps) => {
  const classes = useStyles();
  const { isShowing, toggle } = useModal();

  const modalActions = [
    {
      text: "Close",
      onClick: toggle,
      className: classes.modalBtnClose,
    },
  ];

  const handleRedirectToLearningPathDiscover = () => {
    toggle();
  };

  return (
    <>
      <Grid
        item
        md={column || 4}
        className={classes.lessonCollectibleContainer}
      >
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          className={classes.lessonCollectibleItem}
          onClick={handleRedirectToLearningPathDiscover}
        >
          <Grid container direction="row">
            <div className={classes.imageContainer}>
              <img
                src={imagePath}
                alt="lesson collectible"
                className={classes.img}
              />
            </div>
          </Grid>
          <div className={classes.iconTypeContainer}>
            <LearningTabIcon className={classes.icon} />
            <Typography>Learning</Typography>
          </div>
          <div className={classes.textContainer}>
            <Typography className={classes.description}>
              {title.length > 60 ? `${title.substring(0, 60)}...` : title}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <CustomModal
        title="Lesson Collectible"
        classes={classes}
        isBigModal
        open={isShowing}
        onClose={toggle}
        actions={modalActions}
      >
        <LessonCollectibleDetail slideId={slideId} />
      </CustomModal>
    </>
  );
};

LessonCollectible.defaultProps = {
  column: true,
};

export default LessonCollectible;
